module.exports = __webpack_public_path__ + "media/alert.f00ada06.mp3";